<template>
  <el-container class="app-nav">
    <el-header height="60px">
      <div class="nav-title">4KHD 网盘资源管理系统</div>
      <div class="nav-user">
        <el-button class="menu-btn" icon="el-icon-menu" @click="drawerVisible = true" circle plain type="primary" v-show="isMobile"></el-button>
        <el-dropdown v-show="!isMobile">
          <span class="el-dropdown-link">
            {{ user.username || '用户' }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="goUserInfo">会员信息</el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside width="180px" class="nav-aside" v-show="!isMobile">
        <el-menu :default-active="$route.path === '/' ? '/' : $route.path.split('/')[1]" router>
          <el-menu-item index="/">资源搜索</el-menu-item>
          <el-menu-item index="manageApiKey">API Key管理</el-menu-item>
          <el-menu-item index="userInfo">会员信息</el-menu-item>
          <!-- <el-menu-item v-if="user.role === 'admin'" index="cardGen">卡密生成</el-menu-item> -->
          <el-menu-item v-if="user.role === 'admin'" index="cardManage">卡密管理</el-menu-item>
          <el-menu-item v-if="user.role === 'admin'" index="userManage">用户管理</el-menu-item>
          <el-menu-item index="/adminApiKeyManage" v-if="user.role === 'admin'">
            <i class="el-icon-key"></i>
            <span slot="title">API Key管理（全局）</span>
          </el-menu-item>
          
          <el-menu-item index="/adminApiLogManage" v-if="user.role === 'admin'">
            <i class="el-icon-document"></i>
            <span slot="title">API日志管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="nav-main">
        <keep-alive include="Home">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
    <el-drawer :visible.sync="drawerVisible" direction="ltr" size="70%" :with-header="false" custom-class="mobile-drawer">
      <el-menu :default-active="$route.path === '/' ? '/' : $route.path.split('/')[1]" router @select="drawerVisible = false">
        <el-menu-item index="/">资源搜索</el-menu-item>
        <el-menu-item index="manageApiKey">API Key管理</el-menu-item>
        <el-menu-item index="userInfo">会员信息</el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="cardManage">卡密管理</el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="userManage">用户管理</el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="adminApiKeyManage">API Key管理（全局）</el-menu-item>
        <el-menu-item v-if="user.role === 'admin'" index="adminApiLogManage">API日志管理</el-menu-item>
      </el-menu>
      <div style="margin: 16px; text-align: center;">
        <el-button type="text" @click="goUserInfo">会员信息</el-button>
        <el-button type="text" @click="logout">退出登录</el-button>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
export default {
  name: 'AppNav',
  data() {
    return {
      user: {},
      drawerVisible: false,
      isMobile: false
    }
  },
  created() {
    this.fetchUser();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    async fetchUser() {
      try {
        const res = await this.$axios.get('/user/info', { headers: this.authHeader() });
        if (res && res.code === 200) {
          this.user = res.data || {};
        }
      } catch {}
    },
    goUserInfo() {
      this.$router.push('/userInfo');
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace('/login');
    },
    authHeader() {
      const token = localStorage.getItem('token');
      return token ? { Authorization: 'Bearer ' + token } : {};
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    }
  }
}
</script>

<style scoped>
.app-nav {
  min-height: 100vh;
}
.el-header {
  background: linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%);
  color: #fff;
  font-size: 18px;
  line-height: 60px;
  height: 60px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.menu-btn {
  display: none;
  margin-right: 12px;
}
@media (max-width: 767px) {
  .el-header {
    padding: 0 10px;
    font-size: 16px;
  }
  .nav-title {
    font-size: 1.1rem;
  }
  .nav-user {
    font-size: 14px;
  }
  .menu-btn {
    display: inline-block !important;
  }
  .nav-aside {
    display: none !important;
  }
  .nav-main {
    padding: 10px 2px 0 2px;
  }
}
.nav-title {
  font-weight: 900;
  font-family: 'Orbitron', 'Roboto', 'Arial', sans-serif;
  font-size: 1.5rem;
  letter-spacing: 2px;
  color: #fff;
}
.nav-user {
  font-size: 15px;
  color: #fff;
}
.nav-user ::v-deep .el-dropdown-link {
  color: #fff !important;
}
.nav-aside {
  background: #f5f6fa;
  border-right: 1px solid #e6e6e6;
  min-height: calc(100vh - 60px);
}
.nav-main {
  padding: 24px 24px 0 24px;
  background: #fff;
  min-height: calc(100vh - 60px);
}
.mobile-drawer {
  padding-top: 20px;
}
</style> 